import React, { useEffect, useState } from 'react';
import SideBarStyle from "../../../assets/stylesheets/farm-detail/sections/SideBar.module.css";
// import Logger from "../../../utils/logger";

// const log = Logger.create('OperatingHours');

function formatTo12Hour(time) {
  if (!time) return "";
  const [hourStr, minuteStr] = time.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr;
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // 0 → 12, 13 → 1
  return `${hour}:${minute} ${ampm}`;
}

function isNowOpen(hours) {
  const now = new Date();
  const today = now.toLocaleString('en-US', { weekday: 'short' }); // e.g. "Mon", "Tue"
  const currentTime = now.toTimeString().slice(0, 5); // "HH:mm"

  const todayEntry = hours.find(([day]) => day.startsWith(today));
  if (!todayEntry || !todayEntry[1]) return false;

  const [openRaw, closeRaw] = todayEntry[1].split(" - ") || [];
  if (!openRaw || !closeRaw || openRaw === "null" || closeRaw === "null") return false;

  const open = openRaw.slice(0, 5);
  const close = closeRaw.slice(0, 5);

  return open <= currentTime && currentTime <= close;
}


export default function OperatingHours({hours}) {
  const [openNow, setOpenNow] = useState(false);

  useEffect(() => {
    setOpenNow(isNowOpen(hours));

    const interval = setInterval(() => {
      setOpenNow(isNowOpen(hours));
    }, 60000); // 1분마다 다시 확인

    return () => clearInterval(interval);
  }, [hours]);

  return (
    <div className={SideBarStyle["hours-card"]}>
      <div className={SideBarStyle["hours-header"]}>
        <p className={SideBarStyle["hours-title"]}>Hours</p>
        <span
          className={`${SideBarStyle["hours-status"]} ${
            openNow ? SideBarStyle["status-open"] : SideBarStyle["status-closed"]
          }`}
        >
          {openNow ? "Open now" : "Closed"}
        </span>
      </div>
      <hr className={SideBarStyle["hours-divider"]} />
      <ul className={SideBarStyle["hours-list"]}>
        {hours.map(([day, time], idx) => {
          const isNullRange = /^null\s*-\s*null$/.test(time);
          const isZeroRange = time?.trim() === "00:00:00 - 00:00:00";
          const displayTime =
            (!time || isNullRange || isZeroRange)
              ? "Closed"
              : (() => {
                const [open, close] = time.split(" - ");
                const openFormatted = formatTo12Hour(open.slice(0, 5));
                const closeFormatted = formatTo12Hour(close.slice(0, 5));
                return `${openFormatted} - ${closeFormatted}`;
              })();

          return (
            <li key={idx} className={SideBarStyle["hours-item"]}>
              <span className={SideBarStyle["hours-day"]}>{day}</span>
              <span className={SideBarStyle["hours-time"]}>{displayTime}</span>
            </li>
          );
        })}
      </ul>
      <p className={SideBarStyle["hours-disclaimer"]}>Hours or services may differ.</p>
    </div>
  );
}
